// extracted by mini-css-extract-plugin
export default {"individualKey":"individualKey--vyTFZ","keyGroup":"keyGroup--kK9W5"};